import { faServer } from "@fortawesome/pro-regular-svg-icons/faServer";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { AppMessageBox } from "components/AppMessageBox";
import { AxiosErrorTitle } from "components/CallServer/AxiosHandler";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import AppMessage, { SystemMessages } from "components/Translations/AppMessage";
import HtmlUtils from "lib/HtmlUtils";
import { ApiException } from "models/ApiModels";
import * as React from "react";

interface IProps {
    error: any;
    action?: React.ReactNode;
    resourceId?: SystemMessages;
}

export const RequestErrorReport: React.FC<IProps> = (props) => {
    const { resourceId, error, action } = props;

    if (error == null) return null;

    /////////////////////////////////////

    let stacktrace = null;
    let handledError: ApiException = null;
    let handled: boolean = false;

    if (error && error.hasOwnProperty("handledError")) handledError = error["handledError"];
    if (error && error.hasOwnProperty("handled")) handled = error["handled"];

    if (handledError && handled) {
        // Erro de Requisição HTTP que já foi tratado pelo AxiosHandler.
        // Exibe uma mensagem genérica na página que chamou o recurso.
        return (
            <Grid container>
                <Grid item xs>
                    <AppMessageBox resource={resourceId || "GeneralError"} />
                </Grid>
            </Grid>
        );
    }

    /////////////////////////////////////
    const message = handledError && handledError.errorList && Array.isArray(handledError.errorList) && (handledError.errorList as Array<any>).length > 0
        ? (
            <ul>
                {
                    handledError.errorList.map((v) => {
                        return <li>{v.message}</li>;
                    })
                }
            </ul>
        )
        : handledError && handledError.exceptionMessage
            ? handledError.exceptionMessage
            : error.message != null
                ? error.message
                : error.toString();

    const debug = HtmlUtils.isLocalhost() && handledError?.exceptionCode != 409 && handledError?.exceptionCode != 406;

    if (debug && handledError?.stackTrace) {
        stacktrace = handledError.stackTrace;
    }

    /////////////////////////////////////

    return (
        <Grid container>
            <Grid item xs>

                <MuiMessageBox
                    variant="error"
                    icon={handledError ? faServer : null}
                    message={
                        <>
                            <Typography variant="h5">
                                <AxiosErrorTitle exceptionType={handledError?.exceptionType} />
                            </Typography>

                            {
                                resourceId &&
                                <Typography variant="body1" component="p"><b><AppMessage resource={resourceId} /></b></Typography>
                            }

                            <Typography variant="body2" component="p">
                                {message}
                            </Typography>
                        </>
                    }
                    action={action}
                />

                {
                    stacktrace &&
                    <Box mt={2}>
                        <Card>
                            <CardContent>
                                <h1>Stack Trace</h1>
                                <div style={{ whiteSpace: "pre", overflow: "auto", marginTop: 20 }}>
                                    <code>{stacktrace}</code>
                                </div>
                            </CardContent>
                        </Card>
                    </Box>
                }
            </Grid>
        </Grid>
    );
};